import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class InboxModel extends BaseObject {
    constructor() {
        super();
        this._name = "";
        this._date = 0;
        this._uid = "";
        this._key = "";
        this._os = "";
        this._version = "";
    }

    get version() {
        return this._version;
    }
    set version(value) {
        this._version = value;
    }

    get os() {
        return this._os;
    }
    set os(value) {
        this._os = value;
    }

    get key() {
        return this._key;
    }
    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get date() {
        return this._date;
    }
    set date(value) {
        this._date = value;
    }

    get uid() {
        return this._uid;
    }
    set uid(value) {
        this._uid = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new InboxModel());
        } else if (target instanceof InboxModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(InboxModel, {
    _uid: alias("uid", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _date: alias("date", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _os: alias("os", Schema.primitive()),
    _version: alias("version", Schema.primitive()),
});